export default __webpack_public_path__ + "static/media/green2.adfacfb4.svg";